module.exports = __webpack_public_path__ + "img/qualityFactors@2x.fe8655f.png";